<template>
  <div
    :class="_.desc"
    :style="{
      borderColor: theme.borderColor,
    }"
  >
    <div
      v-if="theme.titleType !== 'none'"
      :class="_.hd"
      :style="{
        marginTop: $transformPx(theme.titleTop),
      }"
    >
      <img :src="theme.title" :class="_.title" />
    </div>
    <div :class="_.bd">
      <div
        ref="content"
        :class="[_.content, 'ql-editor']"
        :style="{
          ...(canFold && isFold
            ? {
                height: `${foldHeight}px`,
                overflow: 'hidden',
              }
            : undefined),
        }"
        v-html="data[0].title"
      />
      <div
        v-if="canFold"
        :class="_.more"
        :style="{
          color: theme.openFontColor,
        }"
        @click="isFold = !isFold"
      >
        <template v-if="isFold">
          展开<van-icon name="arrow-down" :class="_.icon" />
        </template>
        <template v-else>
          收起<van-icon name="arrow-up" :class="_.icon" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data: () => ({
      canFold: false,
      isFold: false,
      foldHeight: 0,
    }),

    mounted() {
      /** @type {HTMLDivElement} */
      const contentEl = this.$refs.content
      const contentHeight = contentEl.getBoundingClientRect().height
      this.foldHeight = this.theme.height * this.$transformPxUnit
      this.canFold = contentHeight > this.foldHeight
      this.isFold = this.canFold
    },
  })
</script>

<style lang="scss" module="_">
  .desc {
    font-size: 0;
    border-radius: var(--border-radius);
    border: 1px solid rgba(252, 233, 206, 0.5);
  }

  .hd {
    text-align: center;

    .title {
      width: auto;
      height: 34px;
    }
  }

  .bd {
    padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
      var(--padding-left);

    .content {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 20px;
      padding: 0;
      height: auto;

      img {
        max-width: 100%;
      }
    }

    .more {
      margin-top: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #ffffff;
      line-height: 17px;

      &:active {
        filter: contrast(0.9);
      }

      .icon {
        margin-left: 4px;
        font-size: 13px;
      }
    }
  }
</style>
